import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import store from "store.js";
import Auth from './Auth/auth'
import { url } from './BaseUrls'

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = url.Our_url;
const API_ROOT_HC = url.hc_base;
const API_ROOT_HC_MASTER = url.hcmasterUrl;
const API_ROOT_HC_EGES = url.EGESBaseUrl;
const API_ROOT_TeamICICI = url.teamicici;

const responseBody = res => res.body;

const responseBodyText = res => res.text;


const setHeaders_MG_Token = req => {
    let tokenMG = store.getState()?store.getState().Auth:"";
    if (tokenMG.user) {
        req.set('authorization', `Bearer token`);
    }
}

const setHeaders_MG = req => {
    let tokenMG = store.getState()?store.getState().Auth:"";
    if (tokenMG.user.MG_TOKEN) {
        req.set('authorization', `Bearer ${tokenMG.user.MG_TOKEN.Data.token}`);
    }
}
const setHeaders_HC = req => {
   
    let tokenHC = store.getState().Auth.user.HC_TOKEN?store.getState().Auth.user.HC_TOKEN.access_token:"";
   
    if (tokenHC) {
        req.set('Authorization', `Bearer ${tokenHC}`);
    }
}
const setHeaders_TM = req => {
    let tokenMG = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZWU0N2IwZGI4OTQyNmEwOGIyYmI3YmQiLCJ1c2VybmFtZSI6IjgxMjgyOTE2MTIiLCJlbWFpbCI6IkhhcmRpa0BpY2ljaWJhbmsuY29tIiwiZmlyc3RuYW1lIjoiSGFyZGlrIiwibGFzdG5hbWUiOiJSYW5hIiwicHJvZmlsZVBpYyI6Imh0dHBzOi8vaXN0b3IuY2RuLm1hbmFnZWFueWNsb3VkLmNvbS9pc3R1ZGlvL2NvZ2RhbV9fMTAwNV9fY29nZGFtX18xMDA1X18yNTAyX19kZV9yYWh1X2ljaWNpYmFua19jb21fXzE1OTQ4OTYwNjQ3MzgvZ3JvdXBfaW1hZ2VfMjAyMDA3MTYxNjExMDRfN2U0NWVjZjFfZmQ3M180MTM1Xzk4NTJfOWJlZGY0OGNjMDVkX29yaWdpbmFsX29yaWdpbmFsLmpwZyIsInJvbGUiOiJ1c2VyIiwiaWF0IjoxNjI0MDE2NzAyLCJleHAiOjE2MjQ2MjE1MDJ9.4Q1AFQYENTMkOrFdC3U2XHhybwBE4BSeLuQB5fcHD3s";
    if (tokenMG) {
        req.set('authorization', `${tokenMG}`);
        req.set('Accept', "application/json");
    }
}

const setHeaders_ApplicantId = req => {
    let ApplicantId = store.getState()?store.getState().Auth.user.MGID:'';
    if(ApplicantId){
        req.set('Applicantid', `${ApplicantId}`)
    }
}





export const requests = {
    postToken: (url, body) =>
        superagent.post(`${API_ROOT}${url}`, body).use(setHeaders_MG_Token).then(responseBody).catch(v=>v),
    get: url =>
        superagent.get(`${API_ROOT}${url}`).use(setHeaders_MG).then(responseBody).catch(v=>v),
    post: (url, body) =>
        superagent.post(`${API_ROOT}${url}`, body).use(setHeaders_MG).then(responseBody).catch(v=>v),
    Textpost: (url, body) =>
        superagent.post(`${API_ROOT}${url}`, body).use(setHeaders_MG).then(responseBodyText).catch(v=>v),
    getHC: url =>
        superagent.get(`${API_ROOT_HC}${url}`).use(setHeaders_HC).then(responseBody).catch(v=>v),
    postHC: (url, body) =>
        superagent.post(`${API_ROOT_HC}${url}`, body).use(setHeaders_HC).then(responseBody).catch(v=>v),
    getHCMaster: (url, body) =>
        superagent.get(`${API_ROOT_HC_MASTER}${url}`).use(setHeaders_HC).then(responseBody).catch(v=>v),
    postHCEGES: (url, body) =>
        superagent.post(`${API_ROOT_HC_EGES}${url}`, body).use(setHeaders_HC).then(responseBody).catch(v=>v),
    postTeamICICI: (url, body) =>
        superagent.post(`${API_ROOT_TeamICICI}${url}`, body).use(setHeaders_TM).then(responseBody).catch(v=>v),
    getWithId: url =>
        superagent.get(`${API_ROOT}${url}`).use(setHeaders_MG).use(setHeaders_ApplicantId).then(responseBody).catch(v=>v),

};

export default {
    Auth
};
